module.exports = __webpack_public_path__ + "img/ico_talk_user_1.2034a1a9.png";